module.exports = __webpack_public_path__ + "img/ic-flag.c7cd3eb7.svg";